import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  snackbarOpen: false,
  snackbarType: 'success',
  snackbarMessage: '',
  snackbarLink: null,
};

const snackbarSlice = createSlice({
  name: 'snackbar',
  initialState,
  reducers: {
    setSnackbar(state, action) {
      state.snackbarOpen = action.payload.snackbarOpen;
      state.snackbarMessage = action.payload.snackbarMessage || '';
      state.snackbarType = action.payload.snackbarType || 'success';
      state.snackbarLink = action.payload.snackbarLink || null;
    },
  },
});

export default snackbarSlice.reducer;

export const { setSnackbar } = snackbarSlice.actions;
